import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';

const EditStudent = () => {
  const [student, setStudent] = useState({
    studentId: '',
    examNumber: '',
    name: '',
    citizenId: '',
    birthDate: '',
    majorCode: '',
    majorName: '',
    admissionMethodCode: '',
    admissionOrder: '',
    expectedEnrollmentDate: '',
    expectedEnrollmentLocation: '',
    notes: ''
  });

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const res = await axios.get(`/students/${id}`, {
          headers: { 'x-auth-token': localStorage.getItem('token') }
        });

        // Chuyển đổi định dạng ngày tháng
        const fetchedStudent = res.data;
        fetchedStudent.birthDate = new Date(fetchedStudent.birthDate).toISOString().split('T')[0];
        fetchedStudent.expectedEnrollmentDate = new Date(fetchedStudent.expectedEnrollmentDate).toISOString().split('T')[0];
        
        setStudent(fetchedStudent);
      } catch (err) {
        console.error(err);
      }
    };

    fetchStudent();
  }, [id]);

  const handleChange = (e) => {
    setStudent({ ...student, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/students/${id}`, student, {
        headers: { 'x-auth-token': localStorage.getItem('token') }
      });
      navigate('/students'); // Redirect to student list after editing
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container>
      <h2>Edit Student</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formExamNumber">
          <Form.Label>Exam Number</Form.Label>
          <Form.Control
            type="text"
            name="examNumber"
            value={student.examNumber}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={student.name}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formCitizenId">
          <Form.Label>Citizen ID</Form.Label>
          <Form.Control
            type="text"
            name="citizenId"
            value={student.citizenId}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formBirthDate">
          <Form.Label>Birth Date</Form.Label>
          <Form.Control
            type="date"
            name="birthDate"
            value={student.birthDate}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formMajorCode">
          <Form.Label>Major Code</Form.Label>
          <Form.Control
            type="text"
            name="majorCode"
            value={student.majorCode}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formMajorName">
          <Form.Label>Major Name</Form.Label>
          <Form.Control
            type="text"
            name="majorName"
            value={student.majorName}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formAdmissionMethodCode">
          <Form.Label>Admission Method Code</Form.Label>
          <Form.Control
            type="text"
            name="admissionMethodCode"
            value={student.admissionMethodCode}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formAdmissionOrder">
          <Form.Label>Admission Order</Form.Label>
          <Form.Control
            type="number"
            name="admissionOrder"
            value={student.admissionOrder}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formExpectedEnrollmentDate">
          <Form.Label>Expected Enrollment Date</Form.Label>
          <Form.Control
            type="date"
            name="expectedEnrollmentDate"
            value={student.expectedEnrollmentDate}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formExpectedEnrollmentLocation">
          <Form.Label>Expected Enrollment Location</Form.Label>
          <Form.Control
            type="text"
            name="expectedEnrollmentLocation"
            value={student.expectedEnrollmentLocation}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formNotes">
          <Form.Label>Notes</Form.Label>
          <Form.Control
            type="text"
            name="notes"
            value={student.notes}
            onChange={handleChange}
          />
        </Form.Group>
        <Button variant="primary" type="submit">Edit Student</Button>
      </Form>
    </Container>
  );
};

export default EditStudent;
